export default (n) => Object.prototype.toString.call(n) === '[object Number]' && n % 1 === 0 && n > 0;
